<template>
  <drop-down icon="pt-2 far fa-bell mr-2" tag="li"
             position="right"
             direction="none"
             class="nav-item btn-rotate dropdown">
    <a slot="title"
       slot-scope="{isOpen}"
       class="nav-link dropdown-toggle responsive-aligh-right"
       data-toggle="dropdown"
       aria-haspopup="true"
       :aria-expanded="isOpen">
      <el-badge class="badge-item" :hidden="total === 0" :value="total" :max="9">
        <i class="pt-2 far fa-bell bell-icon mr-2"/>
      </el-badge>
      <p><span class="d-lg-none d-md-block" style="margin-left: -5px;">{{$t('Notifications')}}</span></p>
    </a>
    <a v-if="total === 0" class="dropdown-item notification">{{$t('No notifications')}}</a>
    <a v-else v-for="notification in notifications"
       class="dropdown-item notification"
       @click="openNotification({ name: 'QueryAnswer', params: { id: notification.id } })">
      <p class="notification-title">{{languageFormatter(notification.object.title)}}</p>
      <label class="notification-date">{{dateFormatter(notification)}}</label>
    </a>
  </drop-down>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import { Badge } from 'element-ui'
  import moment from 'moment'
  import throttle from 'lodash/throttle'

  export default {
    name: 'Notification',
    components: {
      [Badge.name]: Badge
    },
    data () {
      return {
        throttledFetchNotifications: throttle(this.fetchNotifications.bind(this), 30 * 1000)
      }
    },

    mounted () {
      this.fetchNotifications()
    },
    computed: {
      ...mapState('user/notifications', {
        total: state => state.total,
        notifications: state => state.items
      })
    },
    methods: {
      dateFormatter: function (item) {
        return moment(item.createdAt).fromNow()
      },
      languageFormatter: function (item) {
        return this.$options.filters.languageString(item)
      },
      async fetchNotifications () {
        await this.getList({ limit: 10, sf: 'createdAt', so: 'desc' })
      },
      ...mapActions('user/notifications', ['getList']),
      openNotification (params) {
        this.$emit('clicked', true)
        this.$router.push(params)
      }
    },
    watch: {
      '$route' () {
        this.throttledFetchNotifications()
      }
    }
  }
</script>

<style>
  .badge-item {
    margin-right: 7px;
    margin-top: -5px;
  }

  .bell-icon {
    font-size: 20px !important;
  }

  .notification {
    cursor: pointer;
  }

  .notification-title {
    display: inherit !important;
  }

  .notification-date {
    margin: 0;
    font-size: 0.8571em;
    color: #9A9A9A;
    transform: translateY(-5px);
  }

  @media (min-width: 1006px) {
    .responsive-aligh-right {
      text-align: right;
    }
  }

  sup {
    font-size: 75% !important;
  }
</style>
